const MobileShellRoutes = [
  {
    path: '/',
    exact: true,
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: true,
      showWishlist: false,
      showCart: false,
      showSearchBlock: true
    },
    footerConfig: {
      showStickyFooter: true
    }
  },
  {
    path: '/shop/:catstr',
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: true,
      showWishlist: false,
      showCart: false,
      showSearchBlock: true
    },
    footerConfig: {
      showStickyFooter: true
    }
  },
  {
    path: '/search/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showHeader: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/search',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showHeader: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/find/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showHeader: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/find',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/b/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true // default true
    }
  },
  {
    path: '/c/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/s1/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/:str/p/:id',
    exact: true,
    headerConfig: {
      noHeaderTitle: true,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: true,
      showCart: true
    },
    footerConfig: {
      showStickyFooter: false
    }
  },
  {
    path: '/p/:id',
    exact: true,
    headerConfig: {
      noHeaderTitle: true,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: true,
      showCart: true
    },
    footerConfig: {
      showStickyFooter: false
    }
  },
  {
    path: '/cp/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/capsule/:cid',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: true,
      isFooter: true
    }
  },
  {
    path: '/:categoryName/c/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true
    }
  },
  {
    path: '/s/:searchInput',
    headerConfig: {
      noHeaderTitle: true,
      showSearchBar: true,
      showWishlist: false,
      showCart: false
    },
    footerConfig: {
      showStickyFooter: false,
      isFooter: true // default true
    },
  },
  {
    path: '/offline',
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false
    },
    footerConfig: {
      isFooter: true // default true
    }
  },
  {
    path: '/gamezone',
    exact: true,
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: false,
      showCart: false,
      showSearchBlock: false
    },
    footerConfig: {
      showStickyFooter: false
    }
  },
  {
    path: '/gamezone/:gameType',
    exact: true,
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: false,
      showCart: false,
      showSearchBlock: false
    },
    footerConfig: {
      showStickyFooter: false
    }
  },
  {
    path: '/top-shopper',
    exact: true,
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: false,
      showCart: false,
      showSearchBlock: false
    },
    footerConfig: {
      showStickyFooter: false
    }
  },
  {
    path: '/assured-gifts',
    exact: true,
    headerConfig: {
      noHeaderTitle: false,
      noHeaderButtons: false,
      showSearchBar: false,
      showWishlist: false,
      showCart: false,
      showSearchBlock: false
    },
    footerConfig: {
      showStickyFooter: false
    }
  }
];
export default MobileShellRoutes;
